module.exports = __webpack_public_path__ + "img/运维人员.4c9ecf78.png";